// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"RHFCheckbox-module__checkbox","boxDummy":"RHFCheckbox-module__boxDummy"};